import { shape, number, string, bool, arrayOf } from 'prop-types'
import cashflowDatumType from './cashflowDatumType'
import fiscalYearType from './fiscalYearType'
import selectorOptionType from './selectorOptionType'

export default shape({
  applicableYears:           arrayOf(number),
  balanceSheetUrl:           string,
  borrowerType:              string,
  businessScore:             number,
  cashflowData:              arrayOf(cashflowDatumType),
  debtSchedulePending:       bool,
  fiscalYears:               arrayOf(fiscalYearType),
  hasExistingDebt:           bool,
  interimYears:              arrayOf(number),
  name:                      string,
  profitAndLossDocumentUrls: arrayOf(selectorOptionType),
  rid:                       number,
  timeInBusiness:            number
})
